<template>
  <div class="trail-episode-slide py-4 py-md-0">
    <router-link
      class="text-light text-decoration-none"
      :to="{
        name: 'trail-episode',
        params: {
          trail,
          id: resource.id
        }
      }"
    >
      <img :src="img" class="img-fluid" />
      <h6>{{ resource.name }}</h6>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    resource: {
      type: Object,
      default: () => ({})
    },
    trail: [Number, String]
  },
  computed: {
    img() {
      return this.resource.picture || this.resource.thumbnail_vimeo;
    }
  }
};
</script>

<style lang="scss" scoped>
.trail-episode-slide {
  img {
    width: 100%;
    display: block;
    border-radius: 3px;
    margin-bottom: 8px;
  }

  h6 {
    font-size: 14px;
    line-height: 20px;
    padding-right: 20%;
  }
}
</style>
